export enum DocumentUnits {
  inches = 'IN',
  centimetres = 'CM',
  millimetres = 'MM',
}
